import { render, staticRenderFns } from "./Kadrlar.vue?vue&type=template&id=3e538708&"
import script from "./Kadrlar.vue?vue&type=script&lang=js&"
export * from "./Kadrlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports